import { useEffect, useRef, useState } from "react";
import styles from "./RadialProgressBar.module.scss";

interface ProgressBarProps {
  currentValue: number;
  maxValue: number;
}

function RadialProgressBar({ currentValue, maxValue }: ProgressBarProps) {
  const progressRatio = currentValue / maxValue;
  const strokeWidth = 6;
  const radius = 44;
  const svgRef = useRef<SVGSVGElement>(null);
  const [scaleFactor, setScaleFactor] = useState(1);

  useEffect(() => {
    const updateScale = () => {
      if (svgRef.current) {
        const width = svgRef.current.clientWidth;

        setScaleFactor(width / 100);
      }
    };

    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);

  const scaledRadius = radius * scaleFactor;
  const circumference = 2 * Math.PI * scaledRadius;
  const progressOffset = circumference * (1 - Math.min(progressRatio, 1));

  return (
    <svg ref={svgRef} viewBox="0 0 100 100" className={styles.container}>
      {/* Background circle */}
      <circle
        cx="50"
        cy="50"
        r={radius}
        fill="none"
        stroke="var(--color-gray-300)"
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      {/* Progress circle */}
      <circle
        cx="50"
        cy="50"
        r={radius}
        fill="none"
        stroke="var(--color-gray-800)"
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={progressOffset}
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="rotate(-90 50 50)"
        vectorEffect="non-scaling-stroke"
        className={styles.progressCircle}
      />
    </svg>
  );
}

export default RadialProgressBar;
